import React from "react"
import { Link } from "gatsby"
import Img from "gatsby-image"
import styles from "../../styles/global.module.scss"
import ConvertSlug from "../../helpers/convertSlug"

const WorkItemBox = props => {
  const { work_item, slug, index } = props
  let featuredImage
  if (work_item.featuredImage) {
    featuredImage = work_item.featuredImage.childImageSharp.fluid
  } else {
    featuredImage = "/images/na.jpg"
  }
  let work_item_style = styles.workItemLeft
  if (index % 2 === 0) {
    work_item_style = styles.workItemLeft
  } else {
    work_item_style = styles.workItemRight
  }
  return (
    <Link
      to={slug}
      className={`${styles.workItem} ${work_item_style} ${styles.flexWrapper}`}
    >
      <div className={styles.workImgContain}>
        <h3>View Job</h3>
        <Img fluid={featuredImage} />
      </div>
      <div className={styles.workContentContain}>
        <div className={styles.workContentContainText}>
          <h2>{work_item.title}</h2>
          <p className={styles.workCategories}>
            {work_item.categories
              ? work_item.categories.map((cat, i) => {
                  let comma = ", "
                  i === 0 ? (comma = "") : (comma = ", ")
                  return `${comma} ${cat}`
                })
              : null}
          </p>
          <div className={styles.buttonContain}>
            <Link to={slug} className={styles.btn}>
              View Job
            </Link>
          </div>
        </div>
      </div>
    </Link>
  )
}

export default function WorkItems(props) {
  const { projects, page_id } = props

  return (
    <div id={styles.workItemsContain}>
      {projects.map((item, i) => {
        const work_item = item.node.frontmatter
        let slug = ConvertSlug(page_id, item.node.fields.slug, work_item.title)
        return (
          <WorkItemBox work_item={work_item} slug={slug} key={i} index={i} />
        )
      })}
    </div>
  )
}
